import { put, take, select } from 'redux-saga/effects';

import config from '../../config';
import { SAVE_CONFIGURATION, SAVE_URL_PARAMS } from './actions';


function* getConfig() {
  while (true) {
    yield take(SAVE_URL_PARAMS);

    console.time('getConfig#getConfig')

    const { ebook: { rc: readingConfig, user_id: userId } } = yield select(state => state.reader);
    const readingConfigArray = readingConfig.split(':');
    const defaults = config.other.default;
    const lms = readingConfigArray[0] === 'a' ? 'achieve' : 'other';
    const tier = readingConfigArray[1] === 'p' ? 'prod' :
      readingConfigArray[1] === 'i' ? 'intl' : 'default';
    const configuration = config[lms][tier] ? config[lms][tier] : defaults;

    configuration.lms = lms;
    configuration.tier = tier;
    configuration.userId = userId;

    yield put({ type: SAVE_CONFIGURATION, data: configuration });
    console.timeEnd('getConfig#getConfig')
  }
}

export default getConfig;
